"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyPairFromData = exports.generateKeyPairUnsafe = void 0;
const keccak_1 = require("ethereum-cryptography/keccak");
const helpers_1 = require("./helpers");
const util_1 = require("./lib/util");
/**
 * Generate a pseudorandom StarkEx key pair. NOT FOR USE IN PRODUCTION.
 */
function generateKeyPairUnsafe() {
    return keyPairFromData((0, util_1.randomBuffer)(32));
}
exports.generateKeyPairUnsafe = generateKeyPairUnsafe;
/**
 * Generate a STARK key pair deterministically from a Buffer.
 */
function keyPairFromData(data) {
    if (data.length === 0) {
        throw new Error('keyPairFromData: Empty buffer');
    }
    const hashedData = (0, keccak_1.keccak256)(data);
    const hashBN = (0, util_1.hexToBn)(hashedData.toString('hex'));
    const privateKey = hashBN.iushrn(5).toString('hex'); // Remove the last five bits.
    return (0, helpers_1.asSimpleKeyPair)((0, helpers_1.asEcKeyPair)(privateKey));
}
exports.keyPairFromData = keyPairFromData;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9rZXlzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHlEQUF5RDtBQUV6RCx1Q0FHbUI7QUFDbkIscUNBR29CO0FBR3BCOztHQUVHO0FBQ0gsU0FBZ0IscUJBQXFCO0lBQ25DLE9BQU8sZUFBZSxDQUFDLElBQUEsbUJBQVksRUFBQyxFQUFFLENBQUMsQ0FBQyxDQUFDO0FBQzNDLENBQUM7QUFGRCxzREFFQztBQUVEOztHQUVHO0FBQ0gsU0FBZ0IsZUFBZSxDQUFDLElBQVk7SUFDMUMsSUFBSSxJQUFJLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRTtRQUNyQixNQUFNLElBQUksS0FBSyxDQUFDLCtCQUErQixDQUFDLENBQUM7S0FDbEQ7SUFDRCxNQUFNLFVBQVUsR0FBRyxJQUFBLGtCQUFTLEVBQUMsSUFBSSxDQUFDLENBQUM7SUFDbkMsTUFBTSxNQUFNLEdBQUcsSUFBQSxjQUFPLEVBQUMsVUFBVSxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDO0lBQ25ELE1BQU0sVUFBVSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsNkJBQTZCO0lBQ2xGLE9BQU8sSUFBQSx5QkFBZSxFQUFDLElBQUEscUJBQVcsRUFBQyxVQUFVLENBQUMsQ0FBQyxDQUFDO0FBQ2xELENBQUM7QUFSRCwwQ0FRQyJ9